/**
 * Keep a lesson dropped in dead space — the gaps between slots — from navigating the page away.
 * The drag carries text/html so it means something outside the app, and the browser's default for
 * dropping that on an unhandled region is to go to it.
 *
 * Claiming every dragover at capture makes a gap drop a quiet cancel; the slots' own handlers run
 * after this one and still set "move". The drop listener is the backstop for a drop that reaches
 * the document unclaimed.
 *
 * Call while a drag is in flight; the returned teardown removes both listeners.
 */
export function suppressStrayLessonDrops(): () => void {
  const onDragOver = (event: DragEvent) => {
    event.preventDefault()
    if (event.dataTransfer) event.dataTransfer.dropEffect = "none"
  }
  const onDrop = (event: DragEvent) => {
    if (!event.defaultPrevented) event.preventDefault()
  }

  document.addEventListener("dragover", onDragOver, { capture: true })
  document.addEventListener("drop", onDrop)
  return () => {
    document.removeEventListener("dragover", onDragOver, { capture: true })
    document.removeEventListener("drop", onDrop)
  }
}
